
export const Loader = ({ message = "Processing payment...",
    secureText = "🔒 Payment secure by WACEPAY" }
    : { message?: string, secureText?: string }) => (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      backdropFilter: 'blur(5px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
      flexDirection: 'column'
    }}>
      <div style={{
        width: '60px',
        height: '60px',
        border: '5px solid rgba(247, 130, 16, 0.2)',
        borderTop: '5px solid #f78210',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        margin: '20px auto',
        boxShadow: '0 0 20px rgba(56, 85, 160, 0.2)'
      }}></div>
      <p style={{
        color: '#fff',
        fontSize: '0.9em',
        marginTop: '1rem',
        fontWeight: 500,
        textAlign: 'center'
      }}>{message}</p>
       <p style={{
        color: '#fff',
        fontSize: '0.8em',
        marginBottom: '2rem',
        marginTop: '15rem',
        textAlign: 'center',
        width: '100%'
      }}>{secureText}</p>
      <style>
        {`
          @keyframes spin {
            100% { transform: rotate(0deg); }
            0% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
